<template>
  <v-container fluid class="no-padding-top">
    <v-row>
      <v-col class="no-padding-top">
        <div class="text-h6 white--text" v-text="`Orden ${orderIncrementId}`"></div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-skeleton-loader
          type="article"
          height="450"
          :loading="!dataLoaded">
          <v-card outlined v-if="Object.keys(order).length > 1">
            <v-row no-gutters align="center">
              <v-col>
                <v-card-title v-text="`${order.customer_firstname} ${order.customer_lastname}`"></v-card-title>
                <v-card-subtitle class="text-subtitle-1" align="left" v-text="order.customer_email"></v-card-subtitle>
              </v-col>
              <v-col v-if="order.billing_address"><v-card-title class="phone-size" v-text="`Tel: ${order.billing_address.telephone}`"></v-card-title></v-col>
              <v-col><v-card-subtitle align="right" class="text-h5" v-text="$moment(order.created_at).format('hh:mm a')"></v-card-subtitle></v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row
                align="center"
                class="mx-0"
              >
                <v-col><div class="text-subtitle-1">Tipo de Entrega</div></v-col>
                <v-col>
                  <div class="text-h6" v-if="order.shipping_method">
                    <v-chip
                      class="ma-2 text-capitalize"
                      v-text="getPrettyShipping(order.shipping_method)"></v-chip>
                  </div>
                  <div class="text-h6" v-else>
                    <v-chip
                      class="ma-2 text-capitalize"
                      v-text="order.shipping_description"></v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-row
                align="center"
                class="mx-0"
              >
                <v-col><div class="text-subtitle-1">Pago</div></v-col>
                <v-col>
                  <div class="text-h6" v-if="order.payment">
                    <v-chip
                      class="ma-2 text-capitalize"
                      v-text="order.payment.additional_information[0]"></v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text class="no-padding-bottom no-padding-top">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item) in order.items" :key="item.item_id">
                      <td v-if="hasInstructions(item)">
                        <v-row no-gutters align="center">
                          <v-col>
                            <div class="text-subtitle-1" v-text="`(${item.qty_ordered}x)`"></div>
                          </v-col>
                          <v-col>
                            <div v-text="item.name"></div>
                          </v-col>
                          <v-col>
                            <div class="text-h6" align="end" v-text="`$ ${item.price * item.qty_ordered}`"></div>
                          </v-col>
                        </v-row>
                        <v-row no-gutters align="center" v-if="item.options.length > 0">
                          <v-col>
                            <div v-for="option in item.options" :key="option.option_id">
                              <div v-if="option.innerOptions && option.innerOptions.length > 0">
                                <v-list-item
                                  v-for="innerOption in option.innerOptions"
                                  :key="innerOption.option_type_id"
                                  class="no-padding">
                                  <v-list-item-action>
                                    <v-checkbox color="blue darken-2" :input-value="true" :disabled="true"></v-checkbox>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      class="text-h6 font-weight-regular"
                                      v-text="innerOption.title">
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                              <v-list-item v-else-if="option.value">
                                <v-list-item-content class="no-padding">
                                  <v-row no-gutters align="center">
                                    <v-col cols="2">
                                      <div class="text-h6" v-text="option.title"></div>
                                    </v-col>
                                    <v-col cols="10">
                                      <div class="text-h6 font-weight-regular" v-text="option.value"></div>
                                    </v-col>
                                  </v-row>
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                          </v-col>
                        </v-row>
                      </td>
                      <td class="no-padding-right" v-else>
                        <v-row no-gutters align="center">
                          <v-col>
                            <div class="text-subtitle-1" v-text="`(${item.qty_ordered}x)`"></div>
                          </v-col>
                          <v-col>
                            <div v-text="item.name"></div>
                          </v-col>
                          <v-col>
                            <div class="text-h6" align="end" v-text="`$ ${item.price * item.qty_ordered}`"></div>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text class="no-padding-top no-padding-bottom" v-if="order.shipping_amount && order.shipping_amount > 0">
              <v-row align="center">
                <v-col>
                  <div class="text-subtitle-1" align="right">+ Envío</div>
                </v-col>
                <v-col>
                  <div class="text-h6" align="right" v-text="`$ ${order.shipping_amount}`"></div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row align="center">
                <v-col>
                  <div class="text-h6 black--text" align="right">TOTAL</div>
                </v-col>
                <v-col>
                  <div class="text-h6 black--text" align="right" v-text="`${order.global_currency_code}$ ${order.grand_total}`"></div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-text align="center" v-if="showAction">
              <v-btn
                block
                color="error"
                dark
                @click="showCancelDialog = true">
                <v-icon
                  left
                  dark>
                  mdi-close-circle
                </v-icon>
                Cancelar Orden
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card outlined v-else>
            <v-row no-gutters>
              <v-col>
                <v-card-title class="justify-center" v-text="errors.loadingOrder.title"></v-card-title>
              </v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-row no-gutters>
                <v-col>
                  <v-card-subtitle class="text-center text-h6" v-text="errors.loadingOrder.description"></v-card-subtitle>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="showCancelDialog"
        persistent
        max-width="600px">
        <v-form ref="cancelOrderForm">
          <v-card>
            <v-card-title>
              <v-row no-gutters>
                <v-col cols="11">
                  <span class="headline">Cancelar Orden</span>
                </v-col>
                <v-col cols="1" align="right">
                  <v-btn
                    color="grey lighten-1"
                    fab
                    x-small
                    dark
                    @click="abortCancel()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text class="no-padding">
              <v-container fluid class="no-padding-top no-padding-bottom">
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      v-model="cancelText"
                      :rules="cancelTextRules"
                      label="Razón de cancelación"
                      color="blue darken-2"
                      clearable
                      required>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                dark
                @click="cancel()">
                <v-icon
                  left
                  dark>
                  mdi-close-circle
                </v-icon>
                Cancelar Orden
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="showInstructionsDialog"
        persistent
        max-width="800px">
        <v-card>
          <v-card-title class="justify-center">
            <div class="headline">Indicaciones para esta Orden</div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="no-padding-bottom no-padding-top">
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="(item) in order.items" :key="item.item_id">
                    <td v-if="hasInstructions(item)">
                      <v-row no-gutters align="center">
                        <v-col>
                          <div class="text-subtitle-1" v-text="`(${item.qty_ordered}x)`"></div>
                        </v-col>
                        <v-col>
                          <div v-text="item.name"></div>
                        </v-col>
                        <v-col>
                          <div class="text-h6" align="end" v-text="`$ ${item.price * item.qty_ordered}`"></div>
                        </v-col>
                      </v-row>
                      <v-row no-gutters align="center" v-if="item.options.length > 0">
                        <v-col>
                          <div v-for="option in item.options" :key="option.option_id">
                            <div v-if="option.innerOptions && option.innerOptions.length > 0">
                              <v-list-item
                                v-for="innerOption in option.innerOptions"
                                :key="innerOption.option_type_id"
                                class="no-padding">
                                <v-list-item-action>
                                  <v-checkbox color="blue darken-2" :input-value="true" :disabled="true"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="text-h6 font-weight-regular"
                                    v-text="innerOption.title">
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                            <v-list-item v-else-if="option.value">
                              <v-list-item-content class="no-padding">
                                <v-row no-gutters align="center">
                                  <v-col cols="2">
                                    <div class="text-h6" v-text="option.title"></div>
                                  </v-col>
                                  <v-col cols="10">
                                    <div class="text-h6 font-weight-regular" v-text="option.value"></div>
                                  </v-col>
                                </v-row>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-col>
                      </v-row>
                    </td>
                    <td v-else>
                      <v-row no-gutters align="center">
                        <v-col>
                          <div class="text-subtitle-1" v-text="`(${item.qty_ordered}x)`"></div>
                        </v-col>
                        <v-col>
                          <div v-text="item.name"></div>
                        </v-col>
                        <v-col>
                          <div class="text-h6" align="end" v-text="`$ ${item.price * item.qty_ordered}`"></div>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              dark
              @click="showInstructionsDialog = false">
              <v-icon
                left
                dark>
                mdi-checkbox-marked-circle
              </v-icon>
              Correcto, he leído las indicaciones
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import mixins from '../helpers/mixins';

  export default {
    name: 'OrderDetails',
    mixins: [mixins],
    props: {
      orderId: Number,
      orderIncrementId: String,
      showAction: Boolean
    },
    data: () => ({
      dataLoaded: false,
      order: {},
      showCancelDialog: false,
      cancelText: '',
      cancelTextRules: [
        value => !!value || 'El campo es obligatorio',
        value => !!value && value.length > 4 || 'El texto es muy corto'
      ],
      showInstructionsDialog: false,
      errors: {
        loadingOrder: {
          title: 'Error obteniendo la orden :(',
          description: 'Por favor, verifica tu conexión y comunícate con soporte.'
        }
      }
    }),
    beforeMount() {
      this.getDataCall()
        .then((result) => {
          if (result.code == 200) {
            this.order = result.result;
            this.handleInstructionsDialog();

            this.dataLoaded = true;
          } else {
            this.dataLoaded = true;
            // this.handleInstructionsDialog(); // ***
          }
        })
        .catch(() => {
          this.dataLoaded = true;
          // this.handleInstructionsDialog(); // ***
        });
    },
    mounted() {},
    methods: {
    hasInstructions(item) {
      let validInstructions = false;
      if (item.options && item.options.length > 0) {
        item.options.map((option) => {
          if (option.innerOptions && option.innerOptions.length > 0) {
            validInstructions = true;
          } else {
            if (option.value) {
              validInstructions = true;
            }
          }
        });
      }

      return validInstructions;
    },
      handleInstructionsDialog() {
        if (this.order.items && this.order.items.length > 0 && this.showAction) {
          for (const index in this.order.items) {
            const item = this.order.items[index];
            
            if (this.hasInstructions(item)) {
              this.showInstructionsDialog = true;
              break;
            }
          }
        } else {
          this.showInstructionsDialog = false;
        }
      },
      abortCancel() {
        this.showCancelDialog = false;
        this.$refs.cancelOrderForm.reset();
        this.$refs.cancelOrderForm.resetValidation();
      },
      cancel() {
        if (this.$refs.cancelOrderForm.validate()) {
          this.$swal.fire({
            title: 'Cancelando Orden',
            html: 'Espera...',
            allowOutsideClick: false,
            onBeforeOpen: () => {
              this.$swal.showLoading();
              this.abortCancel();
              
              setTimeout(() => {
                this.$swal.close();
                this.$swal.fire({
                  title: 'Correcto!',
                  text: 'Tu orden fué cancelada.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                  onAfterClose: () => {
                    this.$router.go(-1);
                  }
                });
              }, 2000);
            }
          });
        }
      },
      async getDataCall() {
        return await this.$magentoAxios.get(`orders/${this.orderId}`);
      },
    }
  }
</script>

<style scoped>
  .phone-size {
    font-size: 1.20rem !important;
  }
</style>